<!-- Services -->
<section id="services">
    <!-- Section Content -->
    <div class="box-white">
        <div class="wrapper padding-all">
            <div class="row">
                <div class="col-md-9 col-sm-12">
                    <!-- <h4 class="title-big">An Integrated Creative Agency</h4> -->
                    <!-- <div class="space"></div> -->
                    <div class="team-horizontal">
                        <!-- Team Members -->
                        <div class="row">
                            <div class="col-md-12 col-sm-12" *ngFor="let i of data">
                                <div class="team">
                                    <div class="team-pic">
                                        <a href="https://nmpksbank.in/apis/{{i.nmpk_staffPhoto}}" target="_blank"><img src="https://nmpksbank.in/apis/{{i.nmpk_staffPhoto}}" alt="{{i.nmpk_staffName}}" height="" width="100%" class="img-full "></a>
                                    </div>
                                    <div class="team-detail ">
                                        <div class="detail-social ">
                                            <ul class="social-icons nav-default inline clearfix ">
                                                <li><a href="# " class="facebook "><i class="fa fa-facebook "></i></a></li>
                                                <li><a href="# " class="twitter "><i class="fa fa-twitter "></i></a></li>
                                                <li><a href="# " class="google "><i class="fa fa-google-plus "></i></a></li>
                                                <li><a href="# " class="linkedin "><i class="fa fa-linkedin "></i></a></li>
                                            </ul>
                                        </div>
                                        <div class="detail-name text-bold "><a>{{i.nmpk_galleryDesc}} </a></div>
                                    </div>
                                </div>
                                <div class="space "></div>
                            </div>
                        </div>
                        <!-- Team Members End -->
                    </div>
                    <div class="space "></div>
                </div>
                <div class="col-md-3 col-sm-12">
                    <app-side-menu></app-side-menu>
                </div>
            </div>
        </div>
    </div>
    <!-- Section Content End -->

</section>
<!-- Services End -->
